<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb />
      <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4 tw-flex tw-justify-center tw-flex-col">
        <div v-if="isAuthenticated" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-4">
          <div class="tw-px-0 md:tw-px-4 xl:tw-px-16">
            <h2 class="c-gray-text tw-text-xl lg:tw-text-2xl xl:tw-text-3xl">Hello {{authenticatedUser.name}}</h2>
            <h4 class="c-light-blue-text tw-text-base lg:text-base xl:tw-text-xl">Welcome to APA Insurance</h4>
            <h5 class="c-blue-text">Buy, Renew or claim against your policy within minutes</h5>
          </div>
          <div class="tw-px-0 md:tw-px-4 xl:tw-px-16">
            <img class="md:tw-block tw-w-24 md:tw-w-64" src="/images/dashboard/smiley.png" alt="smiley">
          </div>
        </div>

        <div class="tw-w-full tw-flex tw-mt-3 md:tw-mt-6 tw-justify-center tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-px-0 md:tw-px-4 tw-mt-4 md:tw-mt-8 tw-pb-8">
          <div class="tw-flex tw-w-full tw-justify-end tw-px-0 md:tw-px-4">
            <v-card class="c-bg-blue tw-w-full md:tw-w-auto tw-p-3 tw-flex tw-justify-between tw-rounded-lg">
              <img class="tw-px-4" src="/images/icons/car-white.svg" alt="umbrella">
              <div class="tw-flex tw-justify-end tw-flex-col tw-text-right">
                <p class="c-white-text tw-font-bold tw-text-xl">Need an Insurance Cover?</p>
                <h2 class="c-white-text tw-font-light">Get your quote instantly</h2>
                <v-btn id="get-quote" small class="mt-2 tw-w-3/4 tw-self-end" color="secondary" :to="{name: 'Request', query: { toRfq: true }}">Request a Quote</v-btn>
              </div>
            </v-card>
          </div>

          <div class="tw-flex tw-w-full tw-justify-start tw-mt-6 md:tw-mt-0 tw-px-0 md:tw-px-4">
            <v-card color="secondary" class="tw-p-3 tw-w-full md:tw-w-auto tw-rounded-lg tw-flex tw-justify-between">
              <img class="tw-px-4" src="/images/dashboard/umbrella.svg" alt="umbrella">
              <div class="tw-flex tw-justify-end tw-flex-col tw-text-right">
                <p class="c-white-text tw-text-xl tw-font-bold">Need to report a claim?</p>
                <h2 class="c-white-text tw-font-light">Easy claims, no worries</h2>
                <claims-options />
              </div>
            </v-card>
          </div>
        </div>

        <div v-if="quotesLength > 0 && customerId" class="tw-w-full tw-flex tw-justify-center tw-flex-col tw-pb-8">
          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">My Recent Quotes</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>
          <quotes :customerId="customerId" @saved-quotes-loaded="quotesLoaded" />
        </div>
      </v-card>
    </div>
  </default>
</template>

<script>

import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import { mapGetters } from 'vuex';
import Quotes from '@/components/quotes/Quotes';
import ClaimsOptions from '@/components/shared/ClaimsOptions';
import axios from 'axios';
import { log } from '@/utils/errorLogger';

export default {
  components: {
    ClaimsOptions, Quotes, BreadCrumb, Default,
  },
  data() {
    return {
      quotesLength: 1,
      customerId: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  metaInfo: {
    title: 'Dashboard',
  },
  mounted() {
    this.fetchCustomerId();
  },
  methods: {
    async fetchCustomerId() {
      // Parse the attributes from localStorage
      const user = JSON.parse(localStorage.getItem('tempUserAttributes'));

      if (user) {
        const [firstName, lastName] = user.name
          ? user.name.split(' ').map((part) => part.trim())
          : ['', ''];

        const payload = {
          agentid: '',
          dob: '',
          superCustomerId: user.sub,
          email: user.email,
          firstName,
          gender: '',
          mobileNo: user.phone_number,
          isCorporate: false,
          lastName,
          fullname: user.name,
          title: '',
          kraPin: user['custom:kra-pin'],
        };

        const customerInfo = await axios.post('/motor/api/customer/findBySuperId/', {
          superCustomerId: this.authenticatedUser?.sub,
        });

        if (customerInfo.data.data) {
          this.customerId = customerInfo.data.data?.customerId;
          let formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
          formPayload = {
            ...formPayload,
            ...payload,
            customerId: customerInfo.data.data.customerId,
          };
          localStorage.setItem('formPayload', JSON.stringify(formPayload));
        } else {
          try {
            const response = await axios.post('/motor/api/customer/create', payload);
            let formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
            formPayload = {
              ...formPayload,
              ...payload,
              customerId: response.data.data.customerId,
            };
            localStorage.setItem('formPayload', JSON.stringify(formPayload));
          } catch (error) {
            log(error, this, 'fetchCustomerId');
            this.$toast.error('Something went wrong. Please try again');
          }
        }
      }
    },
    quotesLoaded(quotes) {
      this.quotesLength = quotes.length;
    },
  },
};
</script>
